import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Core } from './core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { IHome, IResponse } from '../core.interface';

@Injectable({
  providedIn: 'root',
})
export class HomeS {
  private http = inject(HttpClient);
  private $core = inject(Core);

  private homeDataSignal = signal<IHome | null>(null);

  public homeData = this.homeDataSignal.asReadonly();

  async fetchHomeData(reset: boolean = false): Promise<IHome | null> {
    const current = this.homeDataSignal();

    // 🔹 cache
    if (current && !reset) {
      return current;
    }

    const tenantId = this.$core.selectedBuilding()?.tenantId;

    if (!tenantId) return null;

    try {
      const response = await firstValueFrom(
        this.http.get<IResponse<IHome>>(`${environment.apiUrl}/tenant/${tenantId}/home`),
      );

      this.homeDataSignal.set(this.normalizeHomeData(response.data));

      return response.data;
    } catch (e) {
      console.error('Error getting home:', e);
      return null;
    } finally {
    }
  }

  public clear(): void {
    this.homeDataSignal.set(null);
  }

  private normalizeHomeData(data: IHome): IHome {
    const comparisonsBySupply =
      data.consumptionComparisonsBySupply?.filter((item) => item.meterId == null) ?? null;

    return {
      ...data,
      consumptionComparisonsBySupply: comparisonsBySupply?.length ? comparisonsBySupply : null,
    };
  }
}
